module.exports = __webpack_public_path__ + "static/animated-horse-gif-11-d0f99bf1e41217bd9c576216dd5ab1eb.gif";